/** @format */

import styled from 'styled-components';

export const DotsContainer = styled.div`
  display: flex;
  gap: 4px;
  position: absolute;
  bottom: 12px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
`;
